import React, { useEffect, useRef } from 'react'
import "../QuizPage/Quiz.css"
import { useMediaQuery } from 'react-responsive'

import { Link } from 'react-router-dom'
import logo from "../../assets/financial-breed-images/logo.png"

import logo1 from "../../assets/quiz-img1.webp"
import logo2 from "../../assets/quiz-img2.webp"
import logo3 from "../../assets/quiz-img3.webp"
import logo4 from "../../assets/quiz-img4.webp"
import logo5 from "../../assets/quiz-img5.webp"
import logo6 from "../../assets/quiz-img6.webp"
import logo7 from "../../assets/quiz-img7.webp"

import icon1 from "../../assets/icon-employees.png"
import icon2 from "../../assets/icon-company.png"
import icon3 from "../../assets/icon-handshake.png"

import icon4 from "../../assets/icon-check-shield-2.png"
import icon5 from "../../assets/icon-professionals.png"
import icon6 from "../../assets/icon-money-in-hand.png"

import image1 from "../../assets/business-covid-shutdown.jpg"
import image2 from "../../assets/irs-stimulus-programs.jpg"
import image3 from "../../assets/frustrated-business-owner.jpg"

import FormCard from '../../components/FormCard/FormCard'

var STICKY = false
function QuizPage() {
    const btn = useRef(null);
    const is768 = useMediaQuery({ query: '(max-width: 767px)' })
    const is992 = useMediaQuery({ query: '(max-width: 992px)' })
    const is1440 = useMediaQuery({ query: '(max-width: 1440px)' })



    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || window.document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || window.document.documentElement.clientWidth)
        );
    }


    useEffect(() => {
        window.document.body.onscroll = function () {
            const element = window.document.getElementById("makeItSticky")
            const value = isInViewport(element)
            if (value) {
                // console.log("-------");
                // element.style.display = 'block'
                element.style.position = 'fixed'
                element.style.top = "0px"
            }

            const element2 = window.document.getElementById("removeSticky")
            const value2 = isInViewport(element2)
            // console.log("value2 ", value2);
            if (value2) {
                // console.log("=======");
                // element.style.display = 'none'
                element.style.position = 'sticky'
                element.style.top = "0px"
            }
            const element3 = window.document.getElementById("removeSticky2")
            const value3 = isInViewport(element3)
            // console.log("value3 ", value3);
            if (value3) {
                // console.log("=======");
                // element.style.display = 'none'
                element.style.position = 'sticky'
                element.style.top = "0px"
            }
        }

    })
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light quiz-navbar bg-white pb-md-3 mt-0 pt-2">
                <div className="container-fluid mx-sm-3">
                    <a className="navbar-brand quiz-nav-brand mr-xs-0" href="/">
                        <img src={logo} alt="logo" className='img-fluid' />
                    </a>
                    {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <ul className="navbar-nav mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link" id="removeSticky2" href="tel:+13073126819"><i className="fa-solid fa-phone mx-2"></i>(307)-312-6819</a>
                        </li>
                    </ul>
                </div>
            </nav>

            <section className='quiz-sectionOne px-lg-5 px-sm-0 mx-auto bg-white'>
                <div className="row mx-auto">
                    <div className="col-lg-4 px-md-0  ihk-bg px-sm-5">
                        <div className="content">
                            <FormCard />
                        </div>
                    </div>
                    <div className="col-lg-8 ihk-bg py-2">
                        <div className="right-cont">
                            <h4>Most Business Owners Don’t Realize They Can Qualify To</h4>
                            <h1>Get a Tax Credit Up to <span className='gold gold-underline'>$31,000</span> for Each W2 Employee</h1>
                            <h4>Through the Employee Retention Tax Credit Program</h4>

                            <div className="cont-list">
                                <ul style={{ listStyle: "none" }}>
                                    <li className='d-flex'>
                                        <span className='icon-list'>
                                            <i className="far fa-check-circle"></i>
                                        </span>
                                        <p>Can Qualify in Multiple Ways, Even if You Got PPP, or Didn’t Have Revenue Drop</p>
                                    </li>
                                    <li className='d-flex'>
                                        <span className='icon-list'>
                                            <i className="far fa-check-circle"></i>
                                        </span>
                                        <p>Can Get cash in 30 Days, or Wait 3-9 Months for IRS Processing</p>
                                    </li>
                                    <li className='d-flex'>
                                        <span className='icon-list'>
                                            <i className="far fa-check-circle"></i>
                                        </span>
                                        <p>No Up Front Fees, No Credit Check, and No Limit on Tax Credit Amount</p>
                                    </li>

                                </ul>
                            </div>

                            <h5 className='pb-lg-4'>
                                {
                                    is768 === false ?
                                        <>
                                            <b className='qw9637'>
                                                <span className="cta-arrow-left far fa-arrow-alt-circle-left"></span>&nbsp;
                                                Take the 60sec Quiz to Find Out If You Qualify, and How Much You Can Get
                                            </b>
                                        </>
                                        :
                                        <>
                                            <b>
                                                <div>
                                                    <div className='row mx-auto qw111' style={{ flexDirection: "unset" }}>
                                                        <div className='col-2 text-start'>
                                                            <span className="cta-arrow-down far fa-arrow-alt-circle-down"></span>
                                                        </div>
                                                        <div className='col text-center asd999'>
                                                            Take 60sec Quiz Now
                                                        </div>
                                                        <div className='col-2 text-start'>
                                                            <span className="cta-arrow-down far fa-arrow-alt-circle-down"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b>
                                        </>
                                }
                            </h5>
                        </div>
                    </div>
                </div>
            </section>

            <section className='quiz-sectionTwo px-md-5 px-sm-0'>
                <div className="row mx-5 justify-content-center text-center">
                    <div className="col-lg-4">
                        <div className="content">
                            <h2>$10,000,000s</h2>
                            <h4>In Employee Retention Tax Credits Processed for Businesses Across the Country</h4>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="content">
                            <h2>$31,000+</h2>
                            <h4>Payout possible <b><u>for each W2 employee</u></b>, with no cap on max credit received</h4>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="content">
                            <h2>$200k</h2>
                            <h4>Average Credit Size perERC Application</h4>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center mx-0">
                    {
                        is768 === true ?
                            <>
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                    <div>
                                        <img src={logo1} alt="logo1" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo2} alt="logo2" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo3} alt="logo3" style={{ maxWidth: "130px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo4} alt="logo4" style={{ maxWidth: "130px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo5} alt="logo5" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo6} alt="logo6" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo7} alt="logo7" id='removeSticky' style={{ maxWidth: "120px", margin: "10px 10px", opacity: "0.5" }} />
                                    </div>
                                </div>
                            </>
                            :
                            is992 === true ?
                                <>
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                        <div>
                                            <img src={logo1} alt="logo1" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo2} alt="logo2" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo3} alt="logo3" style={{ maxWidth: "130px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo4} alt="logo4" style={{ maxWidth: "130px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo5} alt="logo5" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo6} alt="logo6" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo7} alt="logo7" id='removeSticky' style={{ maxWidth: "120px", margin: "30px 10px", opacity: "0.5" }} />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div style={{ marginTop: "50px", display: "flex", justifyContent: "space-evenly" }}>
                                        <div>
                                            <img src={logo1} alt="logo1" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo2} alt="logo2" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo3} alt="logo3" style={{ maxWidth: "120px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo4} alt="logo4" style={{ maxWidth: "120px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo5} alt="logo5" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo6} alt="logo6" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo7} alt="logo7" id='removeSticky' style={{ maxWidth: "110px", margin: "0px 10px", opacity: "0.5" }} />
                                        </div>
                                    </div>
                                </>
                    }
                </div>
            </section>

            <section className='quiz-sectionThree'>
                {/* <div className="content">
                    <div className="videoDiv"></div>
                </div> */}

                <div className="row mx-0 justify-content-center">
                    <a className='btn' ref={btn} id='makeItSticky' href="#">Take 60sec Quiz <i className="fas fa-chevron-right"></i></a>
                    {/* <button>Take 60sec Quiz</button> */}
                </div>

                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-md-4">
                            <div className="cards">
                                <div className="circle-icon">
                                    <img src={icon1} alt="" className='img-fluid' />
                                </div>
                                <div className='text'>
                                    <h4>Up to $31,000 per W2 Employee Kept on Payroll</h4>
                                    <p>Can qualify for multiple quarters in 2020 and 2021, up to $31,000 per W2 employee. Average credit is $200,000+.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="cards">
                                <div className="circle-icon">
                                    <img src={icon2} alt="" className='img-fluid' />
                                </div>
                                <div className='text'>
                                    <h4>More Businesses Can Qualify Than They Realize</h4>
                                    <p>Even if their CPA didn’t think they would. Multiple ways to qualify, even if you got a PPP loan, or didn’t have a drop in revenue.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="cards">
                                <div className="circle-icon">
                                    <img src={icon3} alt="" className='img-fluid' />
                                </div>
                                <div className='text'>
                                    <h4>Reasonable Fee Only After You Receive Credit</h4>
                                    <p>We only get paid after you do. Most businesses are getting sent check by the IRS in 3-9 months for credit from overfunded payroll tax.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <section className='quiz-sectionFour'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="imageDiv">
                                <img src={image1} alt="" className='img-fluid' />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="textDiv">
                                <h3>Employee Retention Tax Credit (ERC) Was Put Into Place With Cares Act, But PPP Got All the Attention</h3>
                                <p>The pandemic and relating shutdowns wreaked havoc on businesses, so Congress passed multiple stimulus acts to distribute relief quickly. </p>
                                <p>The two programs that got all the media attention were the PPP and EIDL programs. Most didn’t even know about the ERC program, and even if so, didn’t think they qualified for it (even though it was as good or better than PPP).  </p>
                            </div>
                        </div>
                    </div>

                    <div className="row qsf-2">
                        <div className="col-md-7 col-12">
                            <div className="textDiv">
                                <h3>Program Was Poorly Utilized and Understood (even by CPAs), so Government Doubled-Down</h3>
                                <p>When few businesses took advantage of the program, the government noticed and <b><u>loosed</u></b> the qualification rules substantially, all while <b><u>increasing</u></b> the amount you could get by almost 3x.</p>
                                <p>They <span style={{ color: "#c1ab16" }}><b><u>want</u></b></span> businesses to qualify and get paid, and unlike PPP, have no limits on how much they can send out.</p>
                            </div>
                        </div>
                        <div className="col-md-5 col-12">
                            <div className="imageDiv">
                                <img src={image2} alt="" className='img-fluid' />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-5">
                            <div className="imageDiv">
                                <img src={image3} alt="" className='img-fluid' />
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="textDiv">
                                <h3>Many Businesses Don’t Realize They Can Qualify (for $200k on average), but the Window is Closing</h3>
                                <p>Most businesses don’t realize they actually can qualify, or were told incorrectly by their CPAs that they wouldn’t.</p>
                                <p>The two programs that got all the media attention were the PPP and EIDL programs. Most didn’t even know about the ERC program, and even if so, didn’t think they qualified for it (even though it was as good or better than PPP).  It’s not really the CPA’s fault, as the rules were confusing (and changed multiple times), and this is a very specialized one-time program. That’s why we now offer our:</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className='quiz-sectionFive'>
                <div className="row mx-0 justify-content-center text-center">
                    <div className="heading">
                        <h2>Introducing the 100% Done-For-You ERC Service from FinancialBreed</h2>
                    </div>
                </div>
            </section>

            <section className='quiz-sectionSix bg-white'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-3">
                                    <div className="icon asd6542">
                                        <div className="circle-icon circle-icon12">
                                            <img src={icon4} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-9">
                                    <div className="textDiv">
                                        <h3>Conservative and Honest Numbers for “Sleep Well at Night” Audit Protection</h3>
                                        <p>You’ve worked too hard on your business to jeopardize anything with an IRS audit. Our network of CPAs are conservative with their numbers and calculations, so you’ll be above reproach against agents looking for audits. Unlike many other fly-by-night organizations, we have processed $10,000,000s in ERC Credits, and continue to have great relations with regulatory entities.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-3">
                                    <div className="icon asd6542">
                                        <div className="circle-icon circle-icon12">
                                            <img src={icon5} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-9">
                                    <div className="textDiv">
                                        <h3>Our Network of Licensed Accountants Do All The Hard Work</h3>
                                        <p>We have a network of registered accountants doing all of the work on your credit, from start to finish. They understand the ERC nuances, and make sure everything is done correctly, and will hold up to scrutiny for years to come.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-3">
                                    <div className="icon asd6542">
                                        <div className="circle-icon circle-icon12">
                                            <img src={icon6} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-9">
                                    <div className="textDiv">
                                        <h3>No Repayment, Personal Guarantee or Credit Check</h3>
                                        <p>Because this is a tax credit from the IRS, and not a loan, there is no collateral, personal guarantees or credit check required to receive the tax credit. If you choose to use one of our financing partners to get your money in as little as 30 days, traditional loan info is required. But if you wait the 7-9 months, there is no credit info required.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='quiz-sectionWorks' data-aos="fade-up">
                <div className="row mx-0 justify-content-center text-center">
                    <h2>How It Works</h2>
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="asdew45545">
                            <div className="icon mb-3">
                                <div className="circle-icon">
                                    <h1>1</h1>
                                </div>
                            </div>
                            <div>
                                <h4>Take the Qualification Quiz</h4>
                                <em>60 Seconds</em>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="asdew45545">
                            <div className="icon mb-3">
                                <div className="circle-icon">
                                    <h1 style={{ textShadow: "0px 0px 10px rgb(0 0 0 / 30%)" }}>2</h1>
                                </div>
                            </div>
                            <div>
                                <h4>Fill Out Application (Online or Phone)</h4>
                                <em>60 Seconds</em>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="asdew45545">
                            <div className="icon mb-3">
                                <div className="circle-icon">
                                    <h1>3</h1>
                                </div>
                            </div>
                            <div>
                                <h4>Work With Our Team to Get Docs and Info</h4>
                                <em>60 Seconds</em>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mb-4">
                        <div className="asdew45545">
                            <div className="icon mb-3">
                                <div className="circle-icon">
                                    <h1>4</h1>
                                </div>
                            </div>
                            <div>
                                <h4>Processing, Submission and Payment from IRS</h4>
                                <em>60 Seconds</em>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='quiz-sectionQuiz'>
                <div className="row mx-0 justify-content-center text-center">
                    <div className="headings">
                        <h1>Ready to Get Up $31,000 per W2 Employee?</h1>
                        <h4>Credit currently approved, but rules have changed multiple times.
                            <br />
                            We recommend you claim yours before anything changes.
                        </h4>
                        <a className='btn' href="#">Take 60sec Quiz <i className="fas fa-chevron-right"></i></a>
                    </div>
                </div>
            </section>

            <section className='quiz-sectionFaq'>
                <div className="row mx-0 justify-content-center text-center">
                    <h3>Frequently Asked Questions</h3>
                    <ul className="buttons">
                        <li>
                            <a href="#qualificationCard">Qualification</a>
                        </li>
                        <li>
                            <a href="#taxCreditCard">Tax Credit</a>
                        </li>
                        <li>
                            <a href="#ourCompanyCard">Our Company</a>
                        </li>
                    </ul>
                </div>
                <div className="container">
                    <div className="row mx-0 w-100">
                        <div id='qualificationCard'>
                            <h2>Qualification</h2>
                            <div className="faq-card">

                                <div className="row mt-3 m-0 justify-content-center">
                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample">
                                                    Can I qualify if I’m a 1099 contractor?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample1">
                                                    Unfortunately no. This program is only for companies who paid W2 wages to non-owners.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                                                    Can I qualify if I don’t have any W2 employees?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample2">
                                                    Unfortunately no. This program is only for companies who paid W2 wages to non-owners.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
                                                    Can I qualify for ERC when I got a PPP loan?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample3">
                                                    Yes! There are multiple quarters you can qualify for, even if you got a PPP loan. Unfortunately you can’t use the same covered time period that you used for PPP, which might reduce your ERC amount, but you can most definitely qualify for ERC.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
                                                    What if my revenue went up in 2020 or 2021? Can I still qualify?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample4">
                                                    Yes! It’s called the “Employee Retention” credit, not the “Revenue Reduction” credit. It’s intended to help out the businesses that kept people employed during the hard times of pandemic, so you can qualify even if your revenue went up. You’ll need to qualify using one of the other qualification checks though – shutdowns / mandates or supply chain disruption.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
                                                    How long is the ERC program open for?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample5">
                                                    For most businesses this will be open into 2024 (unless they change the rules again). It’s open as long as you can file amended 941-X returns, which is the later of 3 years from the date you filed your original return, or 2 years from the date you paid the payroll tax.                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
                                                    What if I have bad credit? Is there a credit check involved?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample6">
                                                    It doesn’t matter, because this is not a loan – it’s a tax credit. There are no credit checks, collateral, or personal guarantees required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample7" aria-expanded="false" aria-controls="collapseExample">
                                                    Can I qualify for ERC if my business is now closed?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample7">
                                                    Yes, there is a possibility. It depends on when the business closed.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mx-0 w-100">
                        <div id='taxCreditCard'>
                            <h2 style={{ marginTop: "30px" }}>Tax Credit</h2>
                            <div className="faq-card">
                                <div className="row mt-3 m-0 justify-content-center">

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample8" aria-expanded="false" aria-controls="collapseExample">
                                                    What documents do I need to send you?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample8">
                                                    To complete your tax credit, we’ll work with you and your CPA to get the following documents:
                                                    <ul>
                                                        <li>Payroll Journals outlining all payments, deductions, contributions and taxes for each employee for each paycheck during your ERC eligibility period.</li>
                                                        <li>Filed 941, 943 or 944 payroll reports.</li>
                                                        <li>Profit and Loss Statements (P&Ls) for 2020 and 2021</li>
                                                        <li>Tax returns for 2020 and 2021</li>
                                                        <li>PPP Loan Forgiveness Application (if applicable)</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample9" aria-expanded="false" aria-controls="collapseExample">
                                                    What if I didn’t pay that much in payroll taxes? Will the IRS actually send me a check?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample9">
                                                    Yes! This is a “refundable” tax credit, so that means if the IRS actually owes you more than you paid, it will send you a check for the difference.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample10" aria-expanded="false" aria-controls="collapseExample">
                                                    Do I need to repay the tax credit?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample10">
                                                    Nope! There is nothing to repay with a tax credit. This is not a loan.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample11" aria-expanded="false" aria-controls="collapseExample">
                                                    How long does it take to get my credit?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample11">
                                                    We are generally telling clients between 7-9 months. We take a few weeks to do the work, and the IRS is variable in how long it’s taking to process, but we’re seeing in the 7-9 month range. We do have an option to get you access to a portion of your credit within 30 days.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample12" aria-expanded="false" aria-controls="collapseExample">
                                                    When will the ERC funds run out?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample12">
                                                    There is now set amount of funds set aside for this program, so there is no money that will run out! But you can only submit your amended payroll tax form for up to 3 years after initial filing. The IRS has also changed the rules on this program multiple times, so we recommend applying as soon as possible if you’re interested.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample13" aria-expanded="false" aria-controls="collapseExample">
                                                    What if I have back taxes on my account with the IRS?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample13">
                                                    If you owe back taxes on your account, the IRS will deduct the amount you owe in back taxes from the credit amount, and will pay you the difference.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample14" aria-expanded="false" aria-controls="collapseExample">
                                                    Is the ERC credit taxable?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample14">
                                                    The ERC credit is not actually considered taxable income for federal tax purposes. But what it might do is reduce your company’s deductible wage expenses by the tax credit amount, which will most likely increase your net profit, and therefore what you pay taxes on. Please provide the credit to your CPA or tax preparer for what to do.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample15" aria-expanded="false" aria-controls="collapseExample">
                                                    Will I get in trouble with the IRS for filing?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample15">
                                                    Absolutely not! The IRS created this program and doubled-down on making it easier and more lucrative for businesses, so they really want you to file and use it.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mx-0 w-100">
                        <div id='ourCompanyCard'>
                            <h2 style={{ marginTop: "30px" }}>Our Company</h2>
                            <div className="faq-card">
                                <div className="row mt-3 m-0 justify-content-center">

                                    <div className="col-12 my-2 faq-list">
                                        <div className="faq-item">
                                            <div className="fa-questions">
                                                <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample16" aria-expanded="false" aria-controls="collapseExample">
                                                    How much do you charge?
                                                </p>
                                            </div>
                                            <div className="fa-answers">
                                                <div className="collapse" id="collapseExample16">
                                                    Our fees are paid only after you receive your credit, and depend on the total number of employees, qualifying quarters, etc. Our team will be able to give you a much more accurate quote on fees after we get some details about your business, and how much work it will be.
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ------------------------------- F O O T E R -----------------------------------*/}

            <section className='footer quiz-footer'>
                <div className="row p-5 m-0 justify-content-center">
                    <div className="col-lg-4 col-md-12 col-sm-12 logo">
                        <img src={logo} alt="logo" className='img-fluid' />
                    </div>

                    <div className="col-lg-3 col-md-12 col-sm-12">
                        <div className="col-lg-12">
                            <div className="footer-content mb-4">
                                <span>
                                    <a href="#" className='mb-4'>Privacy Policy</a>
                                    <br />
                                    <br />
                                    <a href="#" className='mb-4'>Terms and Conditions</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="">
                            <div className="footer-content">
                                <p>Phone: <a href="tel:+13073126819" style={{ textDecoration: "none", color: "#333333" }}> (307)-312-6819</a></p>
                                <p>Email: service@financialbreed.com</p>
                                <p>© 2022 FinancialBreed – All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default QuizPage
